const Modal = {
  variants: {
    clean: {
      overlay: {
        bg: 'rgba(0, 0, 0, 0.4)',
      },
      dialog: {
        borderRadius: '12px',
        overflow: 'hidden',
        bg: 'white',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.12)',
      },
      header: {
        pt: 6,
        pb: 4,
        px: 6,
        fontWeight: '600',
        fontSize: 'lg',
        color: 'neutral.800',
        borderBottom: '1px solid',
        borderColor: 'neutral.100',
      },
      body: {
        px: 6,
        py: 4,
      },
      footer: {
        px: 6,
        pb: 6,
        pt: 4,
        borderTop: '1px solid',
        borderColor: 'neutral.100',
      },
      closeButton: {
        top: 4,
        right: 4,
        color: 'neutral.400',
        _hover: { color: 'neutral.600' },
      },
    },
    admin: {
      dialog: {
        borderRadius: '12px',
        overflow: 'hidden',
        bg: 'white',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
      },
      header: {
        pt: 5,
        pb: 4,
        px: 6,
        fontWeight: '600',
        fontSize: 'md',
        color: 'neutral.800',
        borderBottom: '1px solid',
        borderColor: 'neutral.100',
      },
      body: {
        px: 6,
        py: 4,
      },
      footer: {
        px: 6,
        pb: 5,
        pt: 4,
        borderTop: '1px solid',
        borderColor: 'neutral.100',
      },
    },
  },
};

export default Modal;
